import { render, staticRenderFns } from "./CustomerCardManager.vue?vue&type=template&id=ad0e32bc&scoped=true"
import script from "./CustomerCardManager.vue?vue&type=script&lang=js"
export * from "./CustomerCardManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0e32bc",
  null
  
)

export default component.exports